<template>
  <div class="settingWrapper">
    <div class="setting flex-row flex-even">
      <p class="part-name">
        <span>{{ $t('SAAI.CreateGradingPaper.FileSetting.responseNumber') }}</span>
        {{ numberOfAnswer }}
      </p>
      <div class="flex-row flex-center">
        <p class="part-name">
          <span>{{ $t('SAAI.CreateImprovedFeedback.FileSetting.sheetName') }}</span> {{ title }}
        </p>
      </div>
    </div>
    <div class="flex-row flex-spbt">
      <p class="subTitle-dummy"></p>
      <div class="button-wrapper">
        <button
          v-for="sheetNumber in this.numberOfSheets"
          :key="sheetNumber"
          @click="setSheetNumber(sheetNumber - 1)"
        >
          {{ resultsData.data[sheetNumber - 1].sheet }}
        </button>
      </div>
    </div>
    <div class="question flex-row flex-even">
      <p class="part-name">{{ question }}</p>
    </div>
    <TabulatorComponent v-model="answerTableData" :options="options" id="ResultDetailTable"/>
  </div>
</template>
<script>
import { TabulatorComponent } from 'vue-tabulator';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'FileSetting',
  components: {
    TabulatorComponent,
  },
  data() {
    return {
      timer: null,
      answerTableData: [],
      options: {
        columns: [],
      },
      sheetNumber: 0,
    };
  },
  methods: {
    ...mapActions('saaiImprovedFeedback', [
      'AC_SET_TITLE',
      'AC_SET_NUMBER_OF_ANSWER',
      'AC_SET_QUESTION',
      'AC_SET_QUESTIONS',
      'AC_SET_RESULTS_TABLE_DATA'
    ]),
    setColumns(data) {
      const newOptions = [
          { title: 'id', field: 'student_id', width: `7%` },
          {
            title: this.$i18n.locale === 'eng' ? 'response' : '응답',
            field: 'content',
            width: `26%`,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'interval' : '구간',
            field: 'interval_of_student',
            width: `7%`,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'num' : '단어수',
            field: 'keyword_num',
            width: `7%`,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'score' : '점수',
            field: 'score',
            formatter: function (cell) {
              return cell.getValue().toFixed(4);
            },
            width: `10%`,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'missing important keywords' : '빠진 중요어',
            field: 'missing_keywords',
            width: `27%`,
          },
          {
            title: this.$i18n.locale === 'eng' ? 'feedback' : '피드백 문구',
            field: 'feedback_comment',
            width: `16%`,
          },
        ];
      this.options.height = '50vh';
      this.options.placeholder = this.$i18n.locale === 'eng' ? 'Loading data..' : '데이터를 불러오는 중입니다..';
      this.options.columns = newOptions;
    },
    setTableData(paperData) {
      let sheetNumber = this.sheetNumber;
      const excelData = paperData.data[sheetNumber].data.slice(1);
      this.AC_SET_NUMBER_OF_ANSWER(excelData.length);
      const question = paperData.data[sheetNumber].data[0][1].split(' ').join(' ');
      this.AC_SET_QUESTION(question);
      
      const questions = [];
      for (let i = 0; i < paperData.data.length; i++) {
        questions.push(paperData.data[i].data[0][1].split(' ').join(' '));
      }
      this.AC_SET_QUESTIONS(questions);
      
      this.answerTableData = [];
      excelData.forEach((rowData) => {
        const student_id = rowData[0];
        const content = rowData[1];
        const interval_of_student = rowData[5];
        const keyword_num = rowData[2];
        const score = rowData[4];
        const missing_keywords = rowData[3];
        const feedback_comment = rowData[6];
        const newRow = {
          student_id: student_id,
          content: content,
          interval_of_student: interval_of_student,
          keyword_num: keyword_num,
          score: score,
          missing_keywords: missing_keywords,
          feedback_comment: feedback_comment,
        };
        this.answerTableData.push(newRow);
      });
    },
    setResultsData(resultsData) {
      const excelData = resultsData.data
      const resultsTableData = [];

      excelData.forEach((sheet, index) => {
        const sheetData = sheet.data.slice(1);
        const answerTableData = [];

        sheetData.forEach((row, index) => {
          const newRow = {
            student_id: row[0],
            content: row[1],
            interval_of_student: row[5],
            keyword_num: row[2],
            score: row[4],
            missing_keywords: row[3],
            feedback_comment: row[6],
          };
          answerTableData.push(newRow);
        });
        resultsTableData.push(answerTableData);
      });

      this.AC_SET_RESULTS_TABLE_DATA(resultsTableData);
    },
    setSheetNumber(sheetNumber) {
      this.sheetNumber = sheetNumber;
    },
  },
  watch: {
    sheetNumber: function () {
      this.setColumns(this.resultsData);
      this.setTableData(this.resultsData);
    },
    '$i18n.locale': function (newLocale, oldLocale) {
      this.options.columns[1].title = newLocale === 'eng' ? 'response' : '응답';
      this.options.columns[2].title = newLocale === 'eng' ? 'interval' : '구간';
      this.options.columns[3].title = newLocale === 'eng' ? 'num' : '단어수';
      this.options.columns[4].title = newLocale === 'eng' ? 'score' : '점수';
      this.options.columns[5].title =
        newLocale === 'eng' ? 'missing important keywords' : '빠진 중요어';
      this.options.columns[6].title = newLocale === 'eng' ? 'feedback' : '피드백 문구';
    }
  },
  computed: {
    ...mapState('saaiImprovedFeedback', {
      resultsData: (state) => state.resultsData,
      numberOfSheets: (state) => state.numberOfSheets,
      question: (state) => state.question,
      numberOfAnswer: (state) => state.numberOfAnswer,
      title: (state) => state.title,
    }),
  },
  created() {
    this.setColumns(this.resultsData);
    this.setTableData(this.resultsData);
    this.setResultsData(this.resultsData);
  },
};
</script>
<style lang="scss" scoped>
.settingWrapper {
  .setting {
    margin: 15px 0;
    padding: 10px 0;
    border: 2px solid $MAIN-COLOR;
    border-radius: 10px;
    input {
      border-radius: 5px;
      padding: 5px 10px;
      font-size: 1rem;
    }
  }
  .question {
    margin: 15px 0;
    padding: 10px;
    border: 2px solid $MAIN-COLOR;
    border-radius: 10px;
  }
}
.part-name {
  margin-right: 10px;
  span {
    font-weight: bold;
  }
}
.button-wrapper {
  margin: 0px 10px;
  button {
    padding: 5px 10px;
  }
}
#ResultDetailTable {
  box-sizing: border-box;
  max-width: 1200px;
  max-height: none;
  margin: 10px auto 0px auto;
  border-top: 2px solid $MAIN-COLOR;
  border-bottom: 2px solid $MAIN-COLOR;
  border-collapse: collapse;
  table-layout: fixed;
}
</style>
